module.exports = __webpack_public_path__ + "img/logo.1489899a.svg";